// extracted by mini-css-extract-plugin
export default {"item":"ImageCarouselCurrentSlide-module--item--685c2"};